var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 99,
    viewBox: "0 0 69 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.64421 96.2132C0.400449 96.0835 0.308022 95.7807 0.437772 95.5369L2.55215 91.5646C2.6819 91.3208 2.98469 91.2284 3.22845 91.3582C3.47221 91.4879 3.56464 91.7907 3.43489 92.0345L1.55544 95.5654L5.0864 97.4449C5.33017 97.5746 5.42259 97.8774 5.29284 98.1212C5.16309 98.3649 4.8603 98.4574 4.61654 98.3276L0.64421 96.2132ZM68.7049 0.886889C69.7178 25.4645 57.6153 78.976 1.02511 96.2501L0.733167 95.2936C56.704 78.2087 68.7092 25.2771 67.7058 0.928064L68.7049 0.886889Z",
    fill: "#E0CCB8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1a01fd0602fbb7dc6718a9d60e3f58bd.svg";
export { ForwardRef as ReactComponent };